import React from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import Column from "@amzn/meridian/column";

const StaticMetricView = (props) => {
  return (
    <Column spacing={"small"}>
      <Text type="d50">{props.data.value}</Text>
      <Text type="b300" color={"secondary"}>
        <FormattedMessage
          id={props.data.title}
          defaultMessage={props.data.message}
        />
      </Text>
    </Column>
  );
};

export default StaticMetricView;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/StaticMetricView.js